<div class="h-[84px] bg-white shadow-[0px_4px_30px_0px_#E3EAF2]">
    <div class="container flex items-center justify-between gap-[8px] py-[24px]">
        <div class="flex items-center gap-[8px]">
            @if (userDetails) {
                <mat-icon (click)="onMenu()" class="cursor-pointer">menu</mat-icon>
            }

            <button (click)="onLogo()" type="button">
                <img alt="logo" height="34" ngSrc="/assets/images/logo.svg" priority width="250" />
            </button>
        </div>

        @if (userDetails) {
            <button class="account-button" mat-flat-button [matMenuTriggerFor]="menu" type="button">
                <span class="text-[16px] font-semibold text-[#141414]">{{ userDetails.fullName }}</span>
            </button>
        }
    </div>
</div>

<mat-menu #menu="matMenu">
    <button (click)="onLogout()" mat-menu-item type="button">Log Out</button>
</mat-menu>
